<template>
	<div>
		<div v-if="$store.state.user_type!=$keys.WHOLESALER">
			<warehouse-overview/>
		</div>
		<div v-else>
			<wholesaler-overview/>	
		</div>
	</div>
</template>
<script type="text/javascript">

export default{
	components: {
		WholesalerOverview: () => import('./wholesaler-overview/WholesalerOverview.vue'),
		WarehouseOverview: () => import('./warehouse-overview/WarehouseOverview.vue'),
	},
	created(){
		this.$store.dispatch('drawer/setActiveTab',this.$route.name)
	},
}

</script>